<template>
  <svg
    :height="size"
    :width="size"
    fill="none"
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      d="M1.62011 14.41L7.50011 8.52998L13.3901 14.41C13.5255 14.5372 13.7043 14.6081 13.8901 14.6081C14.0759 14.6081 14.2547 14.5372 14.3901 14.41C14.5196 14.2758 14.592 14.0965 14.592 13.91C14.592 13.7234 14.5196 13.5442 14.3901 13.41L8.53011 7.49998L14.4101 1.61998C14.5352 1.48351 14.6046 1.30511 14.6046 1.11998C14.6046 0.934855 14.5352 0.756454 14.4101 0.61998C14.2736 0.494896 14.0952 0.425508 13.9101 0.425508C13.725 0.425508 13.5466 0.494896 13.4101 0.61998L7.50011 6.47998L1.62011 0.58998C1.48163 0.469008 1.30399 0.402344 1.12011 0.402344C0.936233 0.402344 0.75859 0.469008 0.62011 0.58998C0.495026 0.726454 0.425638 0.904855 0.425638 1.08998C0.425638 1.27511 0.495026 1.45351 0.62011 1.58998L6.48011 7.49998L0.59011 13.39C0.460575 13.5242 0.388184 13.7034 0.388184 13.89C0.388184 14.0765 0.460575 14.2558 0.59011 14.39C0.727916 14.522 0.91037 14.5974 1.1012 14.6011C1.29204 14.6048 1.47728 14.5366 1.62011 14.41Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { iconProps } from '../../IconProps'

export default defineComponent({
  name: 'IconCross',
  props: {
    ...iconProps,
  },
})
</script>
